<template>
  <div
    class="kv-ve__row"
    :class="{ selected: selectedRow && !selectedBlockId }"
    @click.stop="$emit('select-row', row)"
  >
    <div class="kv-ve__row-drag" :title="t('visual_editor-drag_row')">⋮⋮</div>
    <div class="kv-ve__row-inner" :style="rowStyle">
      <div class="kv-ve__columns">
        <div v-for="col in row.columns" :key="col.id" class="kv-ve__col">
          <draggable
            v-model="col.blocks"
            group="emailBlocks"
            class="kv-ve__col-drag"
            :ghost-class="'kv-ve__ghost'"
          >
            <VeBlockHost
              v-for="block in col.blocks"
              :key="block.id"
              :block="block"
              :componentName="blockComponent(block.type)"
              :isSelected="selectedBlockId === block.id"
              @select="$emit('select-block', { row, col, block })"
              @duplicate="$emit('duplicate-block', { row, col, block })"
              @delete="$emit('delete-block', { row, col, block })"
            />

            <div v-if="!col.blocks.length" class="kv-ve__drop-empty">
              {{ t('visual_editor-drag_blocks_here') }}
            </div>
          </draggable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import VeBlockHost from "./VeBlockHost.vue";

export default {
  name: "VeRow",
  components: { draggable, VeBlockHost },
  props: {
    row: { type: Object, required: true },
    selectedRowId: { type: String, default: null },
    selectedBlockId: { type: String, default: null },
    blockComponent: { type: Function, required: true },
  },
  methods: {
    t(term, replaces) {
      return this.$root.t(term, replaces);
    },
  },
  computed: {
    selectedRow() {
      return this.selectedRowId === this.row.id;
    },
    rowStyle() {
      const s = this.row.settings || {};
      return {
        backgroundColor: s.backgroundColor || "transparent",
      };
    },
  },
};
</script>


